<template>
  <div>
    <el-row class="mt-3" :gutter="10">
      <el-col
        v-for="(item, index) in tableData"
        :key="index"
        :xs="24"
        :sm="24"
        :md="12"
        :lg="12"
        :xl="8"
      >
        <b-card no-body style="border: 1px solid rgba(0, 0, 0, 0.049)">
          <b-card-body>
            <b-card-title>
              <div class="d-flex justify-content-between">
                <span style="font-size: 20px; color: #606266">
                  {{
                  item.contactName
                  }}
                </span>
                <el-dropdown trigger="click" @command="handleCommand">
                  <a role="button">
                    <i class="el-icon-more" style="font-size: 20px; color: #6c757d"></i>
                  </a>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      icon="el-icon-view"
                      :command="'view:' + item.scmInfoUserContactsCode"
                    >
                      {{
                      $l("table_contact_btn_view") || "查看名片"
                      }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      icon="el-icon-edit"
                      divided
                      :command="'del:' + item.scmInfoUserContactsCode"
                    >
                      {{
                      $l("table_contact_btn_del") || "删除名片"
                      }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="d-flex justify-content-between mt-1">
                <span class="table-text">{{ item.contactJob }}</span>
                <span style="font-size: 15px">
                  <b-badge
                    :variant="item.contactStatus === 'Y' ? 'success' : ''"
                  >{{ item.contactStatusName }}</b-badge>
                </span>
              </div>
            </b-card-title>
            <b-card-text>
              <div>
                <i class="el-icon-mobile-phone table-text"></i>
                <span class="table-text ml-2">{{ item.contactMobile }}</span>
              </div>

              <div>
                <i class="el-icon-phone-outline table-text"></i>
                <span class="table-text ml-2">{{ item.contactPhone }}</span>
              </div>

              <div>
                <i class="el-icon-message table-text" />
                <span class="table-text ml-2">{{ item.contactEmail }}</span>
              </div>
              <div>
                <i class="el-icon-office-building table-text"></i>
                <span class="table-text ml-2">{{ item.companyName }}</span>
              </div>
              <div class="text_description">
                <i class="el-icon-map-location table-text"></i>
                <span class="table-text ml-2">{{ item.companyAddress }}</span>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    viewScmDetail(val) {
      this.$emit("viewScmDetail", val);
    },
    handleCommand(command) {
      this.$emit("handleCommand", command);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-text {
  color: #6c757d;
  font-size: 14.4px;
}
.text_description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 40px;
  line-height: 20px;
}
</style>
